module.exports = __webpack_public_path__ + "img/profile-subscription-active.53cc6a29.svg";